import { useEffect } from "react";

import { CUSTOMER_PORTAL_THEME } from "../constants";
import { customerPortalDefaultTheme } from "../container/themes/customerPortalTheme";
import { useCustomerPortalStore } from "../stores/customerPortal/customerPortalStore";

export const useCustomerPortalColorScheme = () => {
  const theme = useCustomerPortalStore((state) => state.theme);
  const setThemeFromDatabase = useCustomerPortalStore((state) => state.setThemeFromDatabase);
  const setTheme = useCustomerPortalStore((state) => state.setTheme);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const themeString = window.localStorage.getItem(CUSTOMER_PORTAL_THEME);

    if (themeString) {
      try {
        const savedTheme = JSON.parse(themeString);

        setThemeFromDatabase(savedTheme);
      } catch (error) {
        console.error("Error parsing theme from localStorage", error);
        // Fallback to default theme in case of error
        setTheme(customerPortalDefaultTheme);
      }
    }
  }, []);

  return { theme };
};
